export default {
  button: {
    confirm: '确认',
    login: '登录',
  },
}
